<template>
  <div>
    <div class="section-header">
      <div v-html="section.sectionName" />
      <div v-html="section.sectionDescription" />
    </div>

    <div class="section-body">
      <Question v-for="question in section.sectionQuestions" :key="question.questionId"
                :question="question" :view-mode="isViewMode"
                @onAnswered="answerHandler" @onShowHideConditional="showHideConditional"
      />
    </div>
  </div>
</template>

<script>
import Question from "./Questions/Question.vue";

export default {
  name: "SurveyQuestionsScreenSectionCard",
  components: { Question },
  props: {
    'section': { 'type': Object, 'required': true, default() { return {} } },
    'isViewMode': Boolean,
  },
  methods: {
    answerHandler(e) {
      this.$emit('onAnswered', e)
    },
    showHideConditional(option, show) {
      this.$emit('onShowHideConditional', option, show)
    }
  }
}
</script>

<style scoped>

.section-header {
  background-color: #fafafa;
  padding: 16px;
  border-radius: 0.2rem 0.2rem 0 0;
  border: 1px solid #e2e2e2;
  border-bottom: none;
}

.section-body {
  border: 1px solid #e2e2e2;
  border-top: none;
  border-radius: 0 0 0.2rem 0.2rem;
}

</style>